import { AddOnItemMap, BillingOption, FeatureTierLevel, StandardProAddOns, TierItemMap } from '../types';
import { LitElement, css, html } from 'lit';
import { customElement, queryAsync, state } from 'lit/decorators';

import { CartComponent } from '../components/cart-component';
import { StateController } from '../helpers/state/state-management/state-controller';
import accountInfo from '../helpers/state/account-info';
import { getQueryStringParameters } from '../helpers/urls';
import { inIframe } from '../helpers/device';
import { isDefined } from '../helpers/utils';
import topicData from '../helpers/state/topic-data';

@customElement('cart-page')
export class CartPage extends LitElement {
    amplitude_callsite: string = 'Cart Page';

    @queryAsync('#cartElement')
    cartElement!: CartComponent;

    @state()
    tier: FeatureTierLevel = FeatureTierLevel.ProBase;

    @state()
    billing: BillingOption = BillingOption.Quarterly;

    @state()
    addons: StandardProAddOns[] = [];

    @state()
    buttonOnly: boolean = true;

    private readonly bindAccountState = new StateController(this, accountInfo);

    async firstUpdated() {
        await this.startup();
    }

    private async startup() {
        const queryString = getQueryStringParameters();

        const tier_string = queryString.get('tier');
        if (tier_string) {
            this.tier = TierItemMap[tier_string] ;
            this.billing = tier_string.includes('Yearly') ? BillingOption.Annual : tier_string.includes('Every-3-months') ? BillingOption.Quarterly : BillingOption.Monthly;
        }
        const addons_string: string[] =
            queryString
                .get('addons')
                ?.split(',') ?? [];
        this.addons = addons_string.map((addon) => AddOnItemMap[addon]);

        this.buttonOnly = queryString.get('buttonOnly') === 'true';
        window.dispatchEvent(new CustomEvent('page-content-ready'));
    }

    render() {
        return html`
                <div class="points__page_wrapper" style="background-color: ${topicData.topic?.header_text_color};">
                    <cart-component id="cartElement" .in_embed=${inIframe} .billingFrequency=${this.billing} .button_only=${this.buttonOnly} .selectedStandardAddOns=${isDefined(this.addons) ? this.addons : []} .selectedTier=${this.tier}>
                    </cart-component>
                </div>
                <error-toast id="errorToast"></error-toast> `
                ;

    }

    static get styles() {
        return css`

            .form-holder {
                display: flex;
                justify-content: center;
                padding: 3rem 20px;
            }

            .points__page_wrapper {
                display: flex;
                flex-direction: column;
                align-items: center;
                background-image: url(/images/noise.png);
                background-blend-mode: overlay;
                min-height: 100vh;
            }

            .points__content_wrapper {
                display: flex;
                flex-direction: column;
                width: 100%;
                max-width: 1200px;
                justify-content: center;
                background-color: white;
                border-radius: 10px;
            }

            .points__view_map {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                --btn-label-color: white;
                border-radius: 10px 10px 0 0;
            }

            .points__middle_content {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: top;
                padding: 0 25px;
                gap: 25px;
            }


            p {
                margin-top: 5px;
                margin-bottom: 0;
            }

            h2 {
                margin-bottom: 0px;
            }

            h4 {
                margin-top: 5px;
                margin-bottom: 5px;
            }

            .inline_words {
                display: inline-flex;
                flex-direction: row;
                align-items: flex-end;
                justify-content: flex-start;
                gap: 5px;
            }

            .inline_words p {
                margin-bottom: 5px;
            }

            .inline_words h2 {
                margin-top: 0;
            }

            .sparkles {
                height: 20px;
            }

            .hide_on_desktop {
                display: none;
            }

            @media only screen and (max-width: 550px) {
                .points__page_wrapper {
                    padding: 0;
                }

                .points__middle_content {
                    flex-direction: column;
                    align-items: center;
                    padding: 10px;
                }

                .hide_on_mobile {
                    display: none;
                }

                .hide_on_desktop {
                    display: flex;
                }

            }



        `;
    }
}

